let publicIp = '';
let publicIpOms = '';
let homeUrl = '';
if (process.env.REACT_APP_SECRET_ENV === 'development') {
    publicIp ='https://api-bbs2-test.720yun.com';
    publicIpOms ='https://api-oms-test.720yun.com';
    homeUrl = 'https://test.720yun.com/find';
} else if (process.env.REACT_APP_SECRET_ENV === 'alpha') {
    publicIp ='https://api-bbs2-test.720yun.com';
    publicIpOms ='https://api-oms-test.720yun.com';
    homeUrl = 'https://test.720yun.com/find';
} else if (process.env.REACT_APP_SECRET_ENV === 'production') {
    publicIp ='https://api-bbs2.720yun.com';
    publicIpOms ='https://api-oms.720yun.com';
    homeUrl = 'https://720yun.com/find';
}

// 提示时长
const toastDuration = 5;

export { publicIp, toastDuration, homeUrl, publicIpOms }
